import PropTypes from 'prop-types'
import { useState } from 'react'
import { Modal, Button } from 'react-bootstrap'

import { ID_PERFIL_PARTICULAR } from '../../constants/perfiles'
import Opiniones from './calificacionProducto/Opiniones'
import styles from './InformacionVendedor.module.css'

const CANTIDAD_DE_ESTRELLAS_PARA_CALIFICAR = 5

const InformacionVendedor = ({ reputacion, publicacion }) => {
  const [show, setShow] = useState(false)

  const handleClose = () => setShow(false)
  const handleShow = () => reputacion !== 0 && setShow(true)

  const obtenerReputacionEnEstrellas = (reputacion) => {
    if (!reputacion || reputacion.length === 0) {
      return 0
    }
    const promedio = reputacion[0].promedioReputacion // ya viene 1-5
    return Math.round(promedio) // redondeamos a entero (1-5)
  }

  const obtenerReputacion = (reputacion) => {
    if (reputacion === 0) {
      return 'null'
    } else {
      return reputacion.map((e) => (
        <Opiniones
          key={e.idCalificacion}
          calificacion={e.calificacionAlVendedor}
          comentario={e.comentario}
        />
      ))
    }
  }

  return (
    <div className={styles.container}>
      <h2 className={styles.titulo}>Información del vendedor</h2>
      <div className={styles.info}>
        <p className={styles.razonSocial}>
          {publicacion.vendedor.empresa.razonSocial ?? publicacion.vendedor.empresa.nombre}
        </p>

        <div className={styles.badges}>
          {publicacion.idPerfil === ID_PERFIL_PARTICULAR ? (
            <span className={styles.badge}>
              <i className="fa fa-user-circle-o" aria-hidden="true"></i>
              Particular
            </span>
          ) : (
            <span className={styles.badge}>
              <i className="fa fa-building-o" aria-hidden="true"></i>
              Empresa
            </span>
          )}
          {publicacion.vendedor.empresa.emiteFacturaA && (
            <span className={styles.badge}>
              <i className="fa fa-file-text-o" aria-hidden="true"></i>
              Emite Factura A
            </span>
          )}
          {publicacion.vendedor.esTiendaOficial && (
            <span className={styles.badge}>
              <i className="fa fa-star-o" aria-hidden="true"></i>
              Tienda Oficial
            </span>
          )}
        </div>

        <div className={styles.detalles}>
          <p className={styles.detalleFila}>
            <i className="fa fa-calendar" aria-hidden="true"></i>
            Opera desde: {new Date(publicacion.vendedor.fechaAlta).toLocaleDateString('es-AR')}
          </p>
        </div>

        <div className={styles.reputacion}>
          <span
            className={`${styles.puntuacionVendedor} ${reputacion.length > 0 ? styles.linkText : ''} `}
            onClick={handleShow}
          >
            <i className="fa fa-star" aria-hidden="true"></i>
            Puntuación Vendedor
          </span>
          {reputacion === 0 ? (
            <p className={styles.sinPuntaje}>Este vendedor no tiene suficientes calificaciones</p>
          ) : (
            <div className={styles.estrellas}>
              {[...Array(CANTIDAD_DE_ESTRELLAS_PARA_CALIFICAR)].map((_, index) => (
                <i
                  key={index}
                  className={`fa fa-star ${
                    index < obtenerReputacionEnEstrellas(reputacion)
                      ? 'text-warning'
                      : 'text-secondary'
                  }`}
                ></i>
              ))}
            </div>
          )}
        </div>
      </div>
      <Modal
        show={show}
        onHide={handleClose}
        size="lg"
        centered
        contentClassName={styles.modalContent}
      >
        <Modal.Header closeButton className={styles.modalHeader}>
          <Modal.Title className={styles.modalTitle}>Opiniones del Vendedor</Modal.Title>
        </Modal.Header>
        <Modal.Body className={styles.modalBody}>
          <div className={styles.resumen}>
            <p className={styles.resumenLabel}>Puntuación promedio</p>
            <div className={styles.resumenEstrellas}>
              {[...Array(CANTIDAD_DE_ESTRELLAS_PARA_CALIFICAR)].map((_, index) => (
                <i
                  key={index}
                  className={`fa fa-star ${
                    index < obtenerReputacionEnEstrellas(reputacion)
                      ? 'text-warning'
                      : 'text-secondary'
                  }`}
                ></i>
              ))}
            </div>
          </div>

          <p className={styles.opinionesTitulo}>Opiniones</p>
          {reputacion === 0 ? (
            <p className={styles.sinOpiniones}>Todavía no hay opiniones para mostrar</p>
          ) : (
            <div className={styles.opinionesLista}>{obtenerReputacion(reputacion)}</div>
          )}
        </Modal.Body>
        <Modal.Footer className={styles.modalFooter}>
          <Button variant="secondary" className={styles.btnCerrar} onClick={handleClose}>
            Cerrar
          </Button>
        </Modal.Footer>
      </Modal>
    </div>
  )
}

InformacionVendedor.propTypes = {
  reputacion: PropTypes.oneOfType([
    PropTypes.number,
    PropTypes.arrayOf(
      PropTypes.shape({
        idCalificacion: PropTypes.number,
        promedioReputacion: PropTypes.number,
        calificacionAlVendedor: PropTypes.number,
        comentario: PropTypes.string
      })
    )
  ]).isRequired,
  publicacion: PropTypes.shape({
    vendedorNombre: PropTypes.string,
    idPerfil: PropTypes.number,
    fechaAlta: PropTypes.string,
    esTiendaOficial: PropTypes.bool,
    vendedor: PropTypes.shape({
      esTiendaOficial: PropTypes.bool,
      fechaAlta: PropTypes.string,
      usrId: PropTypes.string,
      empresa: PropTypes.shape({
        razonSocial: PropTypes.string,
        nombre: PropTypes.string,
        emiteFacturaA: PropTypes.bool
      })
    })
  }).isRequired
}

export default InformacionVendedor
